/**
 * Check if the current device is a mobile device.
 *
 * @returns {boolean} True if the current device is a mobile device.
 */
export function isMobile() {
	return window.matchMedia( '(max-width: 639px)' ).matches;
}
